import { withChangePasswordSubmit } from '@psyomics/ui-common';
import { BackLink, ChangePasswordForm, PageLayout } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { getConfig } from '../../../config';

const ChangePasswordWithSubmit = withChangePasswordSubmit(ChangePasswordForm);

const ChangePassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { patientApiUrl } = getConfig();

  const handleSuccess = () => {
    navigate('/account/change-password-success');
  };

  return (
    <PageLayout backLink={<BackLink onBack={() => navigate('/account')} text={t('common.buttons.backToMyAccount')} />}>
      <ChangePasswordWithSubmit apiUrl={patientApiUrl} onSuccess={handleSuccess} />
    </PageLayout>
  );
};

export { ChangePassword };
